import { useState } from 'react';

/**
 * Hook to check when a prop has changed since the last render.
 * @example
 * if (usePropChange(prop)) {
 *   setSomeOtherValue(true);
 * }
 * @param prop The prop value to check.
 * @returns True when the prop has changed since the last render, otherwise false.
 */
export const usePropChange = <T>(prop: T) => {
  const [state, setState] = useState(prop);

  if (state !== prop) {
    setState(prop);
    return true;
  }

  return false;
};
